/**
 * Base API Error class
 */
export class ApiError extends Error {
  constructor(
    public statusCode: number,
    message: string,
    public errorCode?: string,
    public details?: Record<string, unknown>,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/**
 * Not Found Error - thrown when resource is not found
 */
export class NotFoundError extends ApiError {
  constructor(message = 'Resource not found') {
    super(404, message);
    this.name = 'NotFoundError';
  }
}

/**
 * Validation Error - thrown when request validation fails
 */
export class ValidationError extends ApiError {
  constructor(message = 'Validation failed') {
    super(422, message);
    this.name = 'ValidationError';
  }
}

/**
 * Server Error - thrown when server has an internal error
 */
export class ServerError extends ApiError {
  constructor(message = 'Server error') {
    super(500, message);
    this.name = 'ServerError';
  }
}

/**
 * Network Error - thrown when network connection fails
 */
export class NetworkError extends Error {
  constructor(message = 'Network connection failed') {
    super(message);
    this.name = 'NetworkError';
  }
}
